import React, { useEffect, useMemo, useState } from 'react';
import { apiService } from '../../services/api';
import AdminLayout from '../../components/admin/AdminLayout';
import { useNavigate } from 'react-router-dom';
import styles from './AdminProducts.module.css';

const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  const fetchProducts = async () => {
    try {
      const data = await apiService.getProducts();
      setProducts(data.products || []);
      console.log(data.products || []);
    } catch {
      setProducts([]);
    }
  };

  const fetchCategories = async () => {
    try {
      const data = await apiService.getCategories();
      const categoriesArray = Array.isArray(data) ? data : (data?.categories || []);
      setCategories(categoriesArray);
    } catch {
      setCategories([]);
    }
  };

  const categoryNameById = useMemo(() => {
    const map = {};
    for (const category of categories) {
      if (category?.id == null) continue;
      map[String(category.id)] = category?.name || '';
    }
    return map;
  }, [categories]);

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('¿Seguro que deseas borrar este producto?')) return;
    try {
      await apiService.deleteProduct(id);
      fetchProducts();
    } catch (err) {
      // Puedes mostrar un alert si quieres feedback
      alert(err.message);
    }
  };

  return (
    <AdminLayout>
      <div className={styles.productManagement}>
        <div className={styles.header}>
          <h1>Gestión de Productos</h1>
          <button className={styles.addButton} onClick={() => navigate('/admin/product-management')}>➕ Agregar Producto</button>
        </div>
        <div className={styles.productsTable}>
          <div className={styles.tableHeader}>
            <div>Producto</div>
            <div>Precio</div>
            <div>Stock</div>
            <div>Categoría</div>
            <div>Estado</div>
            <div>Acciones</div>
          </div>
          {products.map((product) => (
            <div key={product.id} className={styles.tableRow}>
              <div className={styles.productName}>{product.name}</div>
              <div className={styles.productPrice}>${product.price?.toFixed(2)}</div>
              <div className={styles.productStock}>
                <span className={product.stock_quantity < 10 ? styles.lowStock : ''}>
                  {product.stock_quantity}
                </span>
              </div>
              <div className={styles.productCategory}>
                {categoryNameById[String(product.category_id)] || '-'}
              </div>
              <div className={styles.productStatus}>
                <span className={product.is_active ? styles.active : styles.inactive}>
                  {product.is_active ? 'Activo' : 'Inactivo'}
                </span>
              </div>
              <div className={styles.actions}>
                <button className={styles.editButton} onClick={() => navigate(`/admin/products/edit/${product.id}`)}>Editar</button>
                <button className={styles.deleteButton} onClick={() => handleDelete(product.id)}>Borrar</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminProducts;
